export const TICKET_AREAS = {
  BILLING: "Facturación y pagos",
  DOUBTS: "Dudas sobre el curso",
  TECHNICAL_SERVICE: "Servicio técnico",
};
